import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from "../src/context/AuthContext";
import { SocketContextProvider } from "../src/context/SocketContext";
import { AuthAdminContextProvider } from './context/AuthAdminContext';
import { NewMsgContextProvider } from './context/NewMsgContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthAdminContextProvider>
    <AuthContextProvider>
    <SocketContextProvider>
      <NewMsgContextProvider>
					<App />
      </NewMsgContextProvider>
				</SocketContextProvider>
			</AuthContextProvider>
      </AuthAdminContextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
